module.exports = __webpack_public_path__ + "assets/images/lapin-cooking-24cc1d28520dd6a6c2717a4850e6201a.png";